import { c as _c } from "react/compiler-runtime";
import { Grid, type SxProps } from '@mui/material';
import { PageContentBox } from './PageContentBox';
export const PageContent = t0 => {
  const $ = _c(4);
  const {
    children,
    sx
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      height: "95vh"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children || $[2] !== sx) {
    t2 = <Grid xs={12} md={12} sx={t1}><PageContentBox sx={sx}>{children}</PageContentBox></Grid>;
    $[1] = children;
    $[2] = sx;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
};